module.exports = __webpack_public_path__ + "img/n-6.b38e703f.png";